/** Simple event emitter to trigger opening cart/wishlist hovercards programmatically */

type Listener = () => void;

function createEventEmitter() {
    const listeners = new Set<Listener>();
    return {
        subscribe(fn: Listener) {
            listeners.add(fn);
            return () => {
                listeners.delete(fn);
            };
        },
        emit() {
            listeners.forEach(fn => fn());
        },
    };
}

export const cartHovercardEvent = createEventEmitter();
export const wishlistHovercardEvent = createEventEmitter();
